import React from 'react';
import classnames from 'classnames';
import { map, noop, isEqual,isEmpty } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { ForceScroller } from 'modules/force-scroller';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { minimalTabHeader as MinimalTabHeader } from 'ui/views/widgets/minimalTabHeader';
 *
 * // render
 * <MinimalTabHeader propName='propValue'/>
 */
export const minimalTabHeader = ( props ) => {
    const gettingStatusInfo = []
    const primaryCoverageInfo = !isEmpty(props.memberInfo?.mailOrderCoverageInfo) && props.memberInfo?.mailOrderCoverageInfo!=undefined ? props.memberInfo?.mailOrderCoverageInfo.values.map((each) => each.type  === 'PRIMARY' ? gettingStatusInfo.push(each.status) : ''):[];

    // get the tabs data
    const { tabs = [], onChange = noop, selected = null, className } = props;

    const tabclassName = classnames( 'ui-minimal-tab-header', className );

    return (

            <ForceScroller className={ tabclassName }
                arrowStyle={ 'minimal' } gutter={ 0 }
                arrowClassName= { 'ui-minimal-tab-header__arrow' }

                // wrapperContainerClassName={ 'ui-minimal-tab-header__tabs__wrapper' }
                wrapperContainerItemClassName= { 'ui-minimal-tab-header__tab' }
                >

            {/* <div className='ui-minimal-tab-header__tabs'> */}
                { map( tabs, ( tab, tabIndex ) => {

                    const _className = classnames( 'ui-minimal-tab-header__tab__view',  {
                        'ui-minimal-tab-header__tab__view--selected': isEqual( selected, tab.value),
                    } );

                    
                    const statusCheck = `${gettingStatusInfo}` ===  'Inactive' ? 'inactive' : 'active'
                

                    const getMailOrderTitle = () => {
                        
                        return (
                            <div>
                                {getLabel(tab.title)}
                                <span className={statusCheck}>{gettingStatusInfo.length > 0 ? ` (${gettingStatusInfo})` : ''}</span>
                            </div>
                            
                        )
                    }

                    return (
                        <div key={ tabIndex } className={ _className } onClick={ () => onChange( { tab } ) }>
                             {tab.title.value === 'Eligibility' && getLabel( tab.title  )  }
                            {tab.title.value === 'Mail Order' && getMailOrderTitle()  }
                        </div>
                    );
                } ) }

            {/* </div> */}
            </ForceScroller>
           
    );
};

// set display name
minimalTabHeader.displayName = 'minimalTabHeader';

// set default props
minimalTabHeader.defaultProps = {};

// prop types
minimalTabHeader.propTypes = {};
